var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-title-bar-scroll-page',{ref:"container",attrs:{"show-title-bar":_vm.showAppBar,"title":"用户协议"}},[_c('iframe',{attrs:{"height":"100%","src":"https://cdn.keihong.tech/img/202406152226305.html","width":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }